import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageKeys {
    public static readonly CURRENT_USER = "current_user";
    public static readonly USER_IS_SIGNED_OUT = "user_is_signed_out";
    public static readonly ICAD_TOKEN = "icad_token";
    public static readonly SIDEBAR_BACKGROUND_COLOR = "sidebar_backgroung_color";
    public static readonly SIDEBAR_ACTIVE_COLOR = "sidebar_active_color";
    public static readonly LOCAL_VERSION = "local_version";
    public static readonly HIDE_FEATURES = "hide_features";
    public static readonly GLOBAL_SUPPLIER = "global_supplier";
}

